export function getYear () {
  const now = new Date()
  const year = now.getFullYear()
  return {start: year + '-01-01', end: year + '-12-31'}
}

export function formatDate (date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getWeek (thisWeek, lastWeek) {
  const today = new Date()
  const weekNum = today.getDay() === 0 ? 7 : today.getDay()
  const dayNum = today.getDate()
  const end = dayNum + thisWeek - weekNum
  const start = dayNum + lastWeek - weekNum - 7
  return {start: formatDate(new Date(today.getFullYear(), today.getMonth(), start)), end: formatDate(new Date(today.getFullYear(), today.getMonth(), end))}
}

export function getMonth () {
  const today = new Date()
  const start = new Date(today.getFullYear(), today.getMonth(), 1)
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
  return {start: formatDate(new Date(start)), end: formatDate(new Date(end))}
}



// WEBPACK FOOTER //
// ./src/lib/misc.js